import { render } from "./TestKanbanTopHeader.vue?vue&type=template&id=cf2c00fa&scoped=true"
import script from "./TestKanbanTopHeader.vue?vue&type=script&lang=js"
export * from "./TestKanbanTopHeader.vue?vue&type=script&lang=js"

import "./TestKanbanTopHeader.vue?vue&type=style&index=0&id=cf2c00fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf2c00fa"]])

export default __exports__